import React from 'react';
import { connect } from 'react-redux';

import ProductsUtil from '../../app/utils/products';

const PriceComponent = props => (
  <React.Fragment>
    {ProductsUtil.getPrice(props)}
  </React.Fragment>
);

const mapStateToProps = state => ({
  currency: !!(state.contracts && state.contracts.selected) && state.contracts.selected.currency,
});

export default connect(mapStateToProps)(PriceComponent);
